import Route from '@ember/routing/route';

export default class BookmarksRoute extends Route {}
